module.exports = __webpack_public_path__ + "static/advocacy_mobile-cd6fce6b862cecac5579e9685eeef685.webp";